<template>
  <div class="bg-light">
    <div class="words d-flex flex-column justify-content-around">
      <h2 class="important">Peakview Energy Company</h2>
      <div class="person">
        <p>Founded in 2011 to create and develop prospects for oil and gas development.</p>
        <br>
      </div>
    </div>
    <div class="words d-flex flex-column">
      <h2 class="important">Peakview Oil Company</h2>
      <div class="person">
        <p>Peakview Oil Company purchased the Buck Peak oil field in January of 2012. In addition to the oil production, we acquired 8 drilling blocks to expand the Buck Peak field. Peakview Oil Company operates 4 oil wells in Moffat County and another 2 oil wells from the Grassy Creek field in neighboring Routt County. We also have operations in Sweetwater County Wyoming.</p>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Affilates',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.words{
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Affilates.vue